import { useRef } from 'react';
import { useDialogFocus } from './useDialogFocus';
import type { EventPhase } from '../shared/event';

export function EventGate({
  checking,
  error,
  familyBlocked,
  onFamily,
  phase,
  allowAlbumDownloads,
  onRequestAlbum,
}: {
  checking: boolean;
  error: string;
  familyBlocked: boolean;
  onFamily: () => void;
  phase?: EventPhase;
  allowAlbumDownloads: boolean;
  onRequestAlbum: () => void;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useDialogFocus(true, ref, () => {});
  return (
    <div className="event-gate-backdrop">
      <div
        className="event-gate-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="event-gate-title"
        aria-describedby="event-gate-description"
        ref={ref}
        tabIndex={-1}
      >
        <p className="eyebrow">Lloyd’s 90th</p>
        <h2 id="event-gate-title">
          {checking
            ? 'Checking the event…'
            : phase === 'ended'
              ? 'Thank you for celebrating with us.'
              : phase === 'paused'
                ? 'We’re preparing the album.'
                : 'The event hasn’t started yet.'}
        </h2>
        <p id="event-gate-description" role="status">
          {error ||
            (checking
              ? 'One moment while we check the album.'
              : phase === 'ended'
                ? 'The event has ended. If you requested the album, your download link will be emailed once the photos are ready.'
                : phase === 'paused'
                  ? 'We’re currently preparing the album to send out. If you requested a copy, we’ll email you a download link when it’s ready.'
                  : 'We’re getting ready to celebrate. The album will open here automatically when the family starts the event.')}
        </p>
        {!checking && allowAlbumDownloads && phase !== 'ended' && (
          <div className="event-gate-signup">
            <button className="button" onClick={onRequestAlbum}>
              <span aria-hidden="true">&#9993;</span>
              Request the album
            </button>
            <p>{phase === 'paused'
              ? 'Request a copy and we’ll email you when the album is ready.'
              : 'Request now, and we’ll email you a download link after the event finishes.'}</p>
          </div>
        )}
        <button className="secondary-button" disabled={familyBlocked} onClick={onFamily}>
          Family access
        </button>
      </div>
    </div>
  );
}
